import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import type { LegislativeBody } from '../../../../../shared/types';

type Result = ModelHookResult<{
	title: string;
	petitionAsk: string;
}>;

export function useViewMore(legislativeBody: LegislativeBody): Result {
	const {
		data: {
			petition: { ask },
		},
	} = usePetitionDetailsPageData();

	return {
		data: {
			title: `All Members of ${legislativeBody.title}`,
			petitionAsk: ask,
		},
	};
}
